import { useIsLoggedIn } from '@apis/queries/useIsLoggedIn/useIsLoggedIn';
import { useUserPersonalData } from '@apis/queries/useUserPersonalData/useUserPersonalData';
import { isTestEnv } from '@functions/functions';
import getConfig from 'next/config';
import { FC, useEffect } from 'react';
import { io } from 'socket.io-client';
import { useCampaignsSocketEvents } from './hooks/useCampaignsSocketEvents';
import { useDiscordSocketEvents } from './hooks/useDiscordSocketEvents';
import { useFaucetSocketEvents } from './hooks/useFaucetSocketEvents';
import { useGithubSocketEvents } from './hooks/useGithubSocketEvents';
import { useQuestsSocketEvents } from './hooks/useQuestsSocketEvents';
import { useSocket } from './hooks/useSocket';
import useSocketConnectionHandlers from './hooks/useSocketConnectionHandlers';

const { publicRuntimeConfig } = getConfig();

const SOCKET_SERVER_URL = !isTestEnv() ? process.env.SOCKET_SERVER_URL : publicRuntimeConfig.testSocketServerUrl;

const SocketStore: FC = () => {
	const [socket, setSocket] = useSocket();
	const { isLoggedIn } = useIsLoggedIn();
	const { notificationJwt } = useUserPersonalData();

	useGithubSocketEvents();
	useDiscordSocketEvents();
	useFaucetSocketEvents();
	useCampaignsSocketEvents();
	useSocketConnectionHandlers();
	useQuestsSocketEvents();

	useEffect(() => {
		if (!notificationJwt || !isLoggedIn) {
			if (!socket) return;

			setSocket(null);
			return;
		}

		if (!socket) {
			if (!SOCKET_SERVER_URL) {
				console.error('SOCKET_SERVER_URL is not defined');
			}

			console.debug('Socket is not defined, creating new socket');

			const newSocket = io(SOCKET_SERVER_URL, {
				timeout: 5000,
				autoConnect: true,
				auth: {
					token: notificationJwt
				}
			});

			setSocket(newSocket);
		}
	}, [isLoggedIn, notificationJwt, setSocket, socket]);

	return null;
};

export default SocketStore;
